var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.375,
    height: 83.171,
    viewBox: "0 0 82.375 83.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 82.375,
    height: 83.171,
    fill: "#212968"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M249.1,314.172a6.351,6.351,0,0,0-4.751,2.135l-5.271-2.873a1.608,1.608,0,0,0-.763-.194h-17.29a1.6,1.6,0,1,0,0,3.193H237.91l4.981,2.715a6.366,6.366,0,1,0,6.212-4.976m0,3.193a3.173,3.173,0,1,1-3.173,3.173,3.177,3.177,0,0,1,3.173-3.173",
    transform: "translate(-179.182 -255.786)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M204.39,91.359a1.6,1.6,0,0,0,0,3.193H219.6a1.609,1.609,0,0,0,.764-.194l5.27-2.873a6.36,6.36,0,1,0-1.461-2.841l-4.98,2.715Zm25.995-7.279a3.173,3.173,0,1,1-3.173,3.173,3.177,3.177,0,0,1,3.173-3.173",
    transform: "translate(-165.597 -66.051)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M255.858,183.428a6.346,6.346,0,0,0-4.525,1.893l-5.221-4.471a1.6,1.6,0,0,0-1.039-.384H221.845a1.6,1.6,0,1,0,0,3.193h22.638l5.229,4.477a6.366,6.366,0,1,0,6.146-4.709m0,3.194a3.173,3.173,0,1,1-3.173,3.173,3.177,3.177,0,0,1,3.173-3.173",
    transform: "translate(-179.85 -147.366)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M174.828,231.61h21.654a6.367,6.367,0,1,0,0-3.193H174.828a1.6,1.6,0,1,0,0,3.193m24.645-1.6a3.173,3.173,0,1,1,3.173,3.172,3.177,3.177,0,0,1-3.173-3.172",
    transform: "translate(-141.457 -182.626)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M44.061,65.993a1.6,1.6,0,0,0-1.6,1.6,12.211,12.211,0,0,1-9.324,12.132,11.155,11.155,0,0,1-11.959-5.106,14.317,14.317,0,0,0,11.57-18.409,1.6,1.6,0,0,0-2-1.05,1.6,1.6,0,0,0-1.05,2,11.129,11.129,0,1,1-21.556,5.4,11.336,11.336,0,0,1,.144-4.8,4.581,4.581,0,0,0-.422-3.281,8.363,8.363,0,0,1-.541-6.617,1.6,1.6,0,0,0-.593-1.821A8.33,8.33,0,0,1,8.022,31.658a1.593,1.593,0,0,0,.868-1.873,9.929,9.929,0,0,1,1.542-8.473,12.963,12.963,0,0,0,.944,1.207,13.119,13.119,0,0,0,8.951,4.392,5.523,5.523,0,0,0,.667.808,5.437,5.437,0,0,0,3.869,1.61,5.545,5.545,0,0,0,1.247-.143,1.6,1.6,0,0,0,1.2-1.915,1.6,1.6,0,0,0-1.915-1.2,2.293,2.293,0,0,1-2.14-3.855,1.6,1.6,0,0,0-2.259-2.258,5.443,5.443,0,0,0-1.6,3.621,9.93,9.93,0,0,1-7.206-5.589c-.015-.035-.03-.07-.048-.1a9.925,9.925,0,0,1,7.218-13.8,10.1,10.1,0,0,1,5.41.5,5.439,5.439,0,0,0,4.546-.332A8.925,8.925,0,0,1,34.7,3.267c4.427.554,7.765,4.608,7.765,9.428a1.6,1.6,0,0,0,3.194,0C45.658,6.269,41.117.853,35.1.1a12.106,12.106,0,0,0-7.3,1.345,2.263,2.263,0,0,1-1.879.165A13.3,13.3,0,0,0,18.8.942,13.106,13.106,0,0,0,8.188,12.186a13.253,13.253,0,0,0,.662,6.036A13.113,13.113,0,0,0,5.53,29.375,11.523,11.523,0,0,0,3.988,47.934a11.562,11.562,0,0,0,1.066,8.045,1.378,1.378,0,0,1,.138,1A14.492,14.492,0,0,0,5,63.125,14.26,14.26,0,0,0,16.019,74.463a15,15,0,0,0,1.614.243,14.166,14.166,0,0,0,13.076,8.465,15.075,15.075,0,0,0,3.09-.324C40.67,81.4,45.658,74.983,45.658,67.59a1.6,1.6,0,0,0-1.6-1.6",
    transform: "translate(0 0)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M68.976,184.532a1.6,1.6,0,1,0,0,3.194,9.331,9.331,0,0,0,4.941-17.246,1.6,1.6,0,0,0-1.694,2.709,6.136,6.136,0,0,1-3.247,11.343",
    transform: "translate(-55.02 -139.013)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M142.621,70.784a1.6,1.6,0,0,0,2.726,1.129A8.411,8.411,0,0,0,137.5,57.771a1.6,1.6,0,1,0,.717,3.112,5.217,5.217,0,0,1,4.866,8.771,1.587,1.587,0,0,0-.467,1.129",
    transform: "translate(-111.272 -46.997)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M71.827,303.892a1.6,1.6,0,0,0-.75,2.13,1.606,1.606,0,0,0,1.441.908,1.582,1.582,0,0,0,.689-.158,6.914,6.914,0,1,0-9.107-9.455,1.6,1.6,0,1,0,2.826,1.487,3.723,3.723,0,0,1,5.926-.9,3.727,3.727,0,0,1-1.026,5.989",
    transform: "translate(-52.192 -239.766)",
    fill: "#212968"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p-1.eb87ef66e882b13babba3b8d7b9a301c.svg";
export { ForwardRef as ReactComponent };